import type { DiffSide } from "../types.js";

export interface GithubPullRequest {
  apiUrl: string;
  diffUrl: string;
  webUrl: string;
}

export function parseGithubPullRequest(value: string): GithubPullRequest {
  let url;
  try {
    url = new URL(value.trim());
  } catch {
    throw new Error("Enter a valid GitHub URL.");
  }
  const parts = url.pathname.split("/").filter(Boolean);
  if (
    url.protocol !== "https:" ||
    url.hostname !== "github.com" ||
    parts.length < 4 ||
    parts[2] !== "pull" ||
    !/^\d+(?:\.(?:diff|patch))?$/.test(parts[3])
  ) {
    throw new Error("Expected a URL like https://github.com/owner/repo/pull/123.");
  }
  const number = parts[3].replace(/\.(diff|patch)$/, "");
  const owner = encodeURIComponent(parts[0]);
  const repository = encodeURIComponent(parts[1]);
  return {
    apiUrl: `https://api.github.com/repos/${owner}/${repository}/pulls/${number}`,
    diffUrl: `https://github.com/${owner}/${repository}/pull/${number}.diff`,
    webUrl: `https://github.com/${owner}/${repository}/pull/${number}`,
  };
}

export async function hashGithubPath(path: string): Promise<string> {
  const bytes = new TextEncoder().encode(path);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return [...new Uint8Array(digest)]
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}

export function githubLineUrl(
  pullUrl: string,
  pathHash: string,
  side: DiffSide,
  lineNumber: number,
  endLine: number = lineNumber,
): string {
  const lineSide = side === "old" ? "L" : "R";
  const start = Math.min(lineNumber, endLine);
  const end = Math.max(lineNumber, endLine);
  const range = end === start ? "" : `-${lineSide}${end}`;
  return `${pullUrl}/files#diff-${pathHash}${lineSide}${start}${range}`;
}
